import { useState } from 'react'
import * as S from './PromoCodeEditor/PromoCodeSelector.styles'
import PromoCodeForm from './PromoCodeForm/PromoCodeForm'
import './PromoCodeDialog.scss'
import PromoCodeSelector from './PromoCodeEditor/PromoCodeSelector'
import BrowserThemeColor from '../ThemeColor/BrowserThemeColor'
import { useTheme } from 'styled-components'
import { blurActiveElement, useBlurActiveElementOnOpen } from 'utils/mui-utils'

function PromoCodeDialog({ open, onDismiss, onSuccess, source }) {
  const [showPromoCodeForm, setShowPromoCodeForm] = useState(false)
  const theme = useTheme()

  useBlurActiveElementOnOpen(open)

  function clearPromoCodeDialog() {
    // Before the close render: MUI re-renders the dialog root with
    // aria-hidden="true" while focus is still inside it.
    blurActiveElement()
    setShowPromoCodeForm(false)
    onDismiss()
  }

  return (
    <S.Dialog open={open} onDismiss={clearPromoCodeDialog} disableEnforceFocus>
      <BrowserThemeColor
        color={theme.colors.grayBackgroundWhite}
        enabled={open}
      />
      {!showPromoCodeForm ? (
        <PromoCodeSelector
          onDismiss={clearPromoCodeDialog}
          onSuccess={onSuccess}
          setShowPromoCodeForm={setShowPromoCodeForm}
          source={source}
        />
      ) : (
        <PromoCodeForm
          onDismiss={clearPromoCodeDialog}
          onSuccess={onSuccess}
          onClose={() => setShowPromoCodeForm(false)}
          source={source}
        />
      )}
    </S.Dialog>
  )
}

export default PromoCodeDialog
